// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__RbKMT","title":"Menu_title__Ncx0p","dot":"Menu_dot__oDDgb","text-content":"Menu_text-content__iMORN","categories":"Menu_categories__oOUDy"};